var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Profile__General__Page" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "Profile__General__Page__Form" },
      [_c("ProfileMunicipalityTransferDocuments")],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Profile__General__Page__Header" }, [
      _c("h1", [_vm._v("מסמכי הסבה לפי עיריה")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }